import React, { useEffect, useState, useRef } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { Row, Form } from "reactstrap"
import Select from "react-select"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import Loader from "pages/Separate/Loader"
import axios from "axios"
import swal from "sweetalert"
import configure from "configure"
import jsPDF from "jspdf"
import html2canvas from "html2canvas"
import ContractPreview from "./ContractPreview"

const Contract = ({ verticalActiveTab }) => {
  const [fixButtons, setFixButtons] = useState(false)
  const pdfRef = useRef()
  const navigate = useNavigate()
  const params = useParams()

  const [isLoading, setLoading] = useState(false)
  const [commission, setCommissionStructure] = useState(null)
  const [percentage, setPercentage] = useState("")
  const [template_option, setTemplate_option] = useState([])
  const [template, setTemplate] = useState(null)
  const [description, setDescription] = useState("")
  const [description2, setDescription2] = useState("")
  const [customer, setCustomer] = useState("")
  const [link, setLink] = useState("")
  const [contract_id, setContractId] = useState("")
  const [link_enable, setLinkEnable] = useState(false)
  const [signature, setSignature] = useState("")
  const [attachment, setAttachment] = useState(0)
  const [isImageLoaded, setIsImageLoaded] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setFixButtons(window.scrollY > 160)
    }
    document.addEventListener("scroll", handleScroll)
    return () => document.removeEventListener("scroll", handleScroll)
  }, [])

  useEffect(() => {
    if (verticalActiveTab === "6") {
      fetchTemplate()
    }
  }, [verticalActiveTab])

  const fetchTemplate = async () => {
    setLoading(true)
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/contract_templated`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })

      setTemplate_option(
        response.data.data.map(obj => ({
          value: obj.id,
          label: obj.name,
          description: obj.template,
        }))
      )

      const formData = new FormData()
      formData.append("introducer_id", params.id)
      const response2 = await axios({
        method: "post",
        data: formData,
        url: `${configure.nodeApi}/check_introducer_contract`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })

      console.log(`response2`, response2)
      if (response2.data.success) {
        setDescription(response2.data.data?.description || "")
        setDescription2(response2.data.data?.description || "")
        setCustomer(response2.data.data?.customer || "")
        setLink(response2.data.data?.junk_link || "")
        setContractId(response2.data.data?.id || "")
        const option = response.data.data.map(obj => ({
          value: obj.id,
          label: obj.name,
          description: obj.template,
        }))
        setTemplate(
          option.find(obj => obj.value === response2.data.data?.template) ||
          null
        )
        setPercentage(response2.data.data?.percentage || "")
        setCommissionStructure(
          commissionStructure.find(
            obj => obj.value === response2.data.data?.commission
          ) || null
        )
        setSignature(response2.data.data?.signature || "")
        setAttachment(response2.data.data?.attachment || 0)
        if (attachment > 0) {
          setIsImageLoaded(true)
        }
      } else {
        setLinkEnable(true)
      }
      setLoading(false)
    } catch (err) {
      console.error("Error fetching template:", err)
      setLoading(false)
    }
  }

  const generateLink = async e => {
    e.preventDefault()
    setLoading(true)
    const formData = new FormData()
    formData.append("introducer_id", params.id)
    formData.append("contract_id", contract_id)
    formData.append("template", template?.value || "")
    formData.append("description", description)
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/save_introducer_contract`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      setLink(response.data.data)
      swal({
        icon: "success",
        text: "Link Generated Successfully",
      })
      setLoading(false)
    } catch (err) {
      console.error("Error generating link:", err)
      setLoading(false)
    }
  }

  const onSavecontract = async e => {
    e.preventDefault()
    setLoading(true)
    const formData = new FormData()
    formData.append("introducer_id", params.id)
    formData.append("template", template?.value || "")
    formData.append("description", description)
    formData.append("commission", commission?.value || "")
    formData.append("percentage", percentage)
    try {
      await axios({
        method: "post",
        url: `${configure.nodeApi}/store_introducer_contract`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      swal({
        icon: "success",
        text: "Contract Saved Successfully",
      })
      setDescription2("done")
      setLoading(false)
    } catch (err) {
      console.error("Error saving contract:", err)
      setLoading(false)
    }
  }

  const downloadPDF = async () => {
    console.log("starting");
    if (attachment == 1) {
      console.log("attachement passed");
      if (signature) {
        window.open(signature, "_blank")
      } else {
        console.error("No signature/OneDrive link found")
      }
      return
    }
    if (!pdfRef.current) {
      console.error("pdfRef is not assigned to a DOM element")
      return
    }

    if (signature && !isImageLoaded) {
      console.warn("Signature image not loaded yet. Waiting...")
      return
    }

    try {
      setLoading(true)

      await new Promise(resolve => setTimeout(resolve, 0))

      const element = pdfRef.current
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: true,
        backgroundColor: "#ffffff",
      })

      const imgData = canvas.toDataURL("image/png")
      if (!imgData || imgData === "data:,") {
        console.error("Failed to generate canvas image data")
        setLoading(false)
        return
      }

      const pdf = new jsPDF("p", "mm", "a4")
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width
      const totalPages = Math.ceil(
        pdfHeight / pdf.internal.pageSize.getHeight()
      )

      for (let page = 0; page < totalPages; page++) {
        if (page > 0) pdf.addPage()
        const startY = page * pdf.internal.pageSize.getHeight()
        pdf.addImage(imgData, "PNG", 0, -startY, pdfWidth, pdfHeight)
      }

      pdf.save(`IntroducerContract-${contract_id}.pdf`)
    } catch (err) {
      console.error("Error generating PDF:", err)
      swal({
        icon: "error",
        text: "Failed to generate PDF. Please try again.",
      })
    } finally {
      setLoading(false)
    }
  }

  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: "white",
    }),
    menu: base => ({
      ...base,
      zIndex: 50,
    }),
  }

  const commissionStructure = [
    { label: "Percentage", value: "percentage" },
    { label: "Fixed Fee", value: "fixed fee" },
  ]

  const [copy, setCopy] = useState("")
  function copyToClipBoard() {
    {/* Live - earth.zithas.com */ }
    {/* Edemo Live - edemo.zithas.com/live */ }
    {/* edemo - edemo.zithas.com */ }
    const linkToCopy = `https://${configure.domain}/introducer/${link}`
    navigator.clipboard.writeText(linkToCopy)
    setCopy("Copied!")
    setTimeout(() => setCopy(""), 1000)
  }

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="mb-3" style={{ padding: "0 11px 0 12px" }}>
        <Form onSubmit={generateLink}>
          <div
            className={`flex-column fixed-buttons pt-2 ${fixButtons ? "d-flex" : "d-none"
              }`}
          >
            <button
              type="button"
              onClick={onSavecontract}
              className="btn btn-save btn-label pe-0 fix-btn"
            >
              <i className="fas fa-save me-2 label-icon"></i>
              <span>Save</span>
            </button>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn btn-red fix-btn btn-label pe-0"
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>
              <span>Cancel</span>
            </button>
          </div>
          <div ref={pdfRef} className="bg-white px-2 py-4 shadow mb-3">
            <Row>
              <div className="col-md-12 mb-3 text-end">
                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  {/* Group 1: Status + Download */}
                  <div>
                    {signature ? (
                      <span className="badge bg-success p-2">
                        Contract Signed
                      </span>
                    ) : link?.length > 0 ? (
                      <span className="badge bg-danger p-2">
                        Contract Not Signed
                      </span>
                    ) : null}

                    {signature && (
                      <button
                        type="button"
                        onClick={downloadPDF}
                        className="btn btn-secondary btn-sm ms-2"
                        style={{ width: "28px", height: "28px" }}
                        title="Download"
                      >
                        <i className="fas fa-file-download"></i>
                      </button>
                    )}
                  </div>

                  {/* Group 2: Save + Cancel + Copy Link */}
                  <div style={{ marginLeft: "50px" }}>
                    {!signature && link?.length > 0 && (
                      <button
                        type="button"
                        className="btn btn-purple ms-2"
                        onClick={copyToClipBoard}
                      >
                        <i className="fas fa-copy me-1"></i>{" "}
                        {copy || "Copy Link"}
                      </button>
                    )}

                    {!signature && description2?.length > 0 && link?.length == 0 && (
                      <button
                        type="submit"
                        className="btn btn-save btn-label ms-2"
                      >
                        <i className="fas fa-cogs me-1 label-icon"></i> Generate
                        Link
                      </button>
                    )}

                    <button
                      type="button"
                      onClick={onSavecontract}
                      className="btn btn-save btn-label ms-2"
                    >
                      <i className="fas fa-save me-1 label-icon"></i> Save
                    </button>

                    <button
                      type="button"
                      onClick={e => {
                        e.preventDefault()
                        navigate(-1)
                      }}
                      className="btn btn-red btn-label ms-2"
                    >
                      <i className="dripicons-cross me-2 icon-center label-icon"></i>{" "}
                      CANCEL
                    </button>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <label>Select Template</label>
                  <Select
                    placeholder="Select Template"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={template_option}
                    value={template}
                    onChange={e => {
                      setTemplate(e)
                      setDescription(e.description)
                    }}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label>Commission</label>
                  <Select
                    placeholder="Select Commission"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={commissionStructure}
                    value={commission}
                    onChange={e => setCommissionStructure(e)}
                  />
                </div>
                {commission?.value === "percentage" && (
                  <div className="col-md-1 mb-3">
                    <label>(%)</label>
                    <input
                      type="text"
                      placeholder="%"
                      className="form-control"
                      value={percentage}
                      onChange={e => setPercentage(e.target.value)}
                    />
                  </div>
                )}
                {description?.length > 0 && (
                  <div className="col-md-12 mb-3 bd-template">
                    <label>Description</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={description || "<p></p>"}
                      onChange={(event, editor) =>
                        setDescription(editor.getData())
                      }
                    />
                  </div>
                )}
                {signature && attachment == 0 && (
                  <div className="col-md-12 mb-3">
                    <label>Signature</label>
                    <img
                      src={signature}
                      alt="Contract Signature"
                      style={{ maxWidth: "200px", height: "auto" }}
                      onLoad={() => {
                        console.log("Signature image loaded")
                        setIsImageLoaded(true)
                      }}
                      onError={() =>
                        console.error("Failed to load signature image")
                      }
                    />
                  </div>
                )}
              </div>
            </Row>
          </div>
        </Form>
        {/* Hidden PDF Preview */}
        <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
          <ContractPreview
            ref={pdfRef}
            description={description}
            signature={signature}
            contractId={contract_id}
            sign_name={customer}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Contract